import { SyntheticEvent } from "react"

/**
 * WARNING: This is an anti-pattern and shouldn't be used.
 * @param fn
 */
export function staticEvent<T extends SyntheticEvent>(fn: (event: T) => void) {
    return (event: T) => {
        event.preventDefault()
        event.stopPropagation()
        fn(event)
    }
}

type EventCallback<K extends keyof DocumentEventMap> = (
    event: DocumentEventMap[K]
) => void
export function listen(
    selectorOrValidator:
        | string
        | ((target: EventTarget | Document | null) => boolean)
) {
    const eventFns: [keyof DocumentEventMap, (e: any) => void][] = []
    return {
        for: <K extends keyof DocumentEventMap>(event: K) => {
            const callbacks: EventCallback<K>[] = []
            const unsubscribed: number[] = []

            const fn = (e: DocumentEventMap[K]) => {
                const run = () =>
                    callbacks.forEach((cb, i) => {
                        if (!unsubscribed.includes(i)) cb(e)
                    })
                switch (typeof selectorOrValidator) {
                    case "string":
                        if (
                            e.target ===
                            document.querySelector(selectorOrValidator)
                        )
                            run()
                        break
                    case "function":
                        if (selectorOrValidator(e.target)) run()
                }
            }

            document.addEventListener(event, fn)
            eventFns.push([event, fn])

            return {
                do: (callback: EventCallback<K>) => {
                    const cbIndex = callbacks.length
                    callbacks.push(callback)
                    return {
                        unsubscribe: () => {
                            unsubscribed.push(cbIndex)
                        }
                    }
                }
            }
        },
        unsubscribeAll: () => {
            eventFns.forEach(([event, callback]) =>
                document.removeEventListener(event, callback)
            )
        }
    }
}
